import Styled from 'styled-components'
import { transparentize } from 'polished'

export default Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => transparentize(0.5, props.theme.colors.black)};
`



// WEBPACK FOOTER //
// ./src/components/Backdrop/index.js